import ContactService from 'src/modules/contact/contactService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'CONTACT_VIEW';

const contactViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: contactViewActions.FIND_STARTED,
      });

      const record = await ContactService.find(id);

      dispatch({
        type: contactViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: contactViewActions.FIND_ERROR,
      });

      getHistory().push('/contact');
    }
  },
};

export default contactViewActions;
